export const DictionaryPhotoshop_pt_BR = [
    {
        id: 1,
        label: 'Photoshop > Sobre o Photoshop...',
        placement: 'MenuBar',
        name: 'Sobre o Photoshop...',
    },
    {
        id: 10,
        label: 'Arquivo > Novo...',
        placement: 'MenuBar',
        name: 'Novo...',
    },
    {
        id: 20,
        label: 'Arquivo > Abrir...',
        placement: 'MenuBar',
        name: 'Abrir...',
    },
    {
        id: 22,
        label: 'Arquivo > Abrir como objeto inteligente...',
        placement: 'MenuBar',
        name: 'Abrir como objeto inteligente...',
    },
    {
        id: 30,
        label: 'Arquivo > Salvar',
        placement: 'MenuBar',
        name: 'Salvar',
    },
    {
        id: 31,
        label: 'Arquivo > Fechar',
        placement: 'MenuBar',
        name: 'Fechar',
    },
    {
        id: 32,
        label: 'Arquivo > Salvar como...',
        placement: 'MenuBar',
        name: 'Salvar como...',
    },
    {
        id: 33,
        label: 'Arquivo > Salvar uma cópia...',
        placement: 'MenuBar',
        name: 'Salvar uma cópia...',
    },
    {
        id: 34,
        label: 'Arquivo > Reverter',
        placement: 'MenuBar',
        name: 'Reverter',
    },
    {
        id: 36,
        label: 'Photoshop > Sair do Photoshop',
        placement: 'MenuBar',
        name: 'Sair do Photoshop',
    },
    {
        id: 37,
        label: 'Arquivo > Fechar todas',
        placement: 'MenuBar',
        name: 'Fechar todas',
    },
    {
        id: 46,
        label: 'Arquivo > Fechar "Outros"',
        placement: 'MenuBar',
        name: 'Fechar "Outros"',
    },
    {
        id: 101,
        label: 'Editar > Desfazer',
        placement: 'MenuBar',
        name: 'Desfazer',
    },
    {
        id: 103,
        label: 'Editar > Recortar',
        placement: 'MenuBar',
        name: 'Recortar',
    },
    {
        id: 104,
        label: 'Editar > Copiar',
        placement: 'MenuBar',
        name: 'Copiar',
    },
    {
        id: 105,
        label: 'Editar > Colar',
        placement: 'MenuBar',
        name: 'Colar',
    },
    {
        id: 106,
        label: 'Editar > Apagar',
        placement: 'MenuBar',
        name: 'Apagar',
    },
    {
        id: 132,
        label: 'Editar > Refazer',
        placement: 'MenuBar',
        name: 'Refazer',
    },
    {
        id: 133,
        label: 'Editar > Alternar o último estado',
        placement: 'MenuBar',
        name: 'Alternar o último estado',
    },
    {
        id: 177,
        label: 'Arquivo > Imprimir uma cópia',
        placement: 'MenuBar',
        name: 'Imprimir uma cópia',
    },
    {
        id: 1001,
        label: 'Janela > Organizar > Nova Janela',
        placement: 'MenuBar',
        name: 'Nova Janela',
    },
    {
        id: 1002,
        label: 'Visualizar > Réguas',
        placement: 'MenuBar',
        name: 'Réguas',
    },
    {
        id: 1004,
        label: 'Visualizar > Mais zoom',
        placement: 'MenuBar',
        name: 'Mais zoom',
    },
    {
        id: 1005,
        label: 'Visualizar > Menos zoom',
        placement: 'MenuBar',
        name: 'Menos zoom',
    },
    {
        id: 1006,
        label: 'Imagem > Modo > Bitmap',
        placement: 'MenuBar',
        name: 'Bitmap',
    },
    {
        id: 1007,
        label: 'Imagem > Modo > Tons de cinza',
        placement: 'MenuBar',
        name: 'Tons de cinza',
    },
    {
        id: 1008,
        label: 'Imagem > Modo > Duotônico',
        placement: 'MenuBar',
        name: 'Duotônico',
    },
    {
        id: 1009,
        label: 'Imagem > Modo > Cores Indexadas',
        placement: 'MenuBar',
        name: 'Cores Indexadas',
    },
    {
        id: 1010,
        label: 'Imagem > Modo > Cores RGB',
        placement: 'MenuBar',
        name: 'Cores RGB',
    },
    {
        id: 1011,
        label: 'Imagem > Modo > Cores CMYK',
        placement: 'MenuBar',
        name: 'Cores CMYK',
    },
    {
        id: 1014,
        label: 'Imagem > Modo > Multicanal',
        placement: 'MenuBar',
        name: 'Multicanal',
    },
    {
        id: 1016,
        label: 'Selecionar > Cancelar seleção',
        placement: 'MenuBar',
        name: 'Cancelar seleção',
    },
    {
        id: 1017,
        label: 'Selecionar > Tudo',
        placement: 'MenuBar',
        name: 'Tudo',
    },
    {
        id: 1018,
        label: 'Selecionar > Inverter',
        placement: 'MenuBar',
        name: 'Inverter',
    },
    {
        id: 1019,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 1021,
        label: 'Janela > Canais',
        placement: 'MenuBar',
        name: 'Canais',
    },
    {
        id: 1025,
        label: 'Janela > Configurações do pincel',
        placement: 'MenuBar',
        name: 'Configurações do pincel',
    },
    {
        id: 1029,
        label: 'Editar > Definir predefinição de pincel...',
        placement: 'MenuBar',
        name: 'Definir predefinição de pincel...',
    },
    {
        id: 1030,
        label: 'Imagem > Tamanho da imagem...',
        placement: 'MenuBar',
        name: 'Tamanho da imagem...',
    },
    {
        id: 1031,
        label: 'Imagem > Tamanho da tela de pintura...',
        placement: 'MenuBar',
        name: 'Tamanho da tela de pintura...',
    },
    {
        id: 1032,
        label: 'Arquivo > Colocar incorporado...',
        placement: 'MenuBar',
        name: 'Colocar incorporado...',
    },
    {
        id: 1033,
        label: 'Selecionar > Aumentar',
        placement: 'MenuBar',
        name: 'Aumentar',
    },
    {
        id: 1034,
        label: 'Selecionar > Semelhante',
        placement: 'MenuBar',
        name: 'Semelhante',
    },
    {
        id: 1035,
        label: 'Selecionar > Modificar > Borda...',
        placement: 'MenuBar',
        name: 'Borda...',
    },
    {
        id: 1036,
        label: 'Selecionar > Modificar > Difusão...',
        placement: 'MenuBar',
        name: 'Difusão...',
    },
    {
        id: 1037,
        label: 'Camada > Reflexão da luz > Remover Borda...',
        placement: 'MenuBar',
        name: 'Remover Borda...',
    },
    {
        id: 1038,
        label: 'Editar > Definir Padrão...',
        placement: 'MenuBar',
        name: 'Definir Padrão...',
    },
    {
        id: 1040,
        label: 'Editar > Colar especial > Colar Em',
        placement: 'MenuBar',
        name: 'Colar Em',
    },
    {
        id: 1042,
        label: 'Editar > Preencher...',
        placement: 'MenuBar',
        name: 'Preencher...',
    },
    {
        id: 1043,
        label: 'Editar > Traçar...',
        placement: 'MenuBar',
        name: 'Traçar...',
    },
    {
        id: 1044,
        label: 'Imagem > Cortar',
        placement: 'MenuBar',
        name: 'Cortar',
    },
    {
        id: 1045,
        label: 'Imagem > Modo > Tabela de cores...',
        placement: 'MenuBar',
        name: 'Tabela de cores...',
    },
    {
        id: 1046,
        label: 'Janela > Cor',
        placement: 'MenuBar',
        name: 'Cor',
    },
    {
        id: 1052,
        label: 'Imagem > Modo > Cores Lab',
        placement: 'MenuBar',
        name: 'Cores Lab',
    },
    {
        id: 1055,
        label: 'Janela > Informações',
        placement: 'MenuBar',
        name: 'Informações',
    },
    {
        id: 1058,
        label: 'Janela > Origem do Clone',
        placement: 'MenuBar',
        name: 'Origem do Clone',
    },
    {
        id: 1065,
        label: 'Janela > Demarcadores',
        placement: 'MenuBar',
        name: 'Demarcadores',
    },
    {
        id: 1080,
        label: 'Imagem > Aparar...',
        placement: 'MenuBar',
        name: 'Aparar...',
    },
    {
        id: 1081,
        label: 'Imagem > Revelar todas',
        placement: 'MenuBar',
        name: 'Revelar todas',
    },
    {
        id: 1093,
        label: 'Imagem > Cobertura...',
        placement: 'MenuBar',
        name: 'Cobertura...',
    },
    {
        id: 1098,
        label: 'Janela > Camadas',
        placement: 'MenuBar',
        name: 'Camadas',
    },
    {
        id: 1099,
        label: 'Camada > Nova > Camada...',
        placement: 'MenuBar',
        name: 'Camada...',
    },
    {
        id: 1100,
        label: 'Camada > Excluir > Camada',
        placement: 'MenuBar',
        name: 'Camada',
    },
    {
        id: 1103,
        label: 'Camada > Opções do conteúdo de camada...',
        placement: 'MenuBar',
        name: 'Opções do conteúdo de camada...',
    },
    {
        id: 1105,
        label: 'Visualizar > Cores de prova',
        placement: 'MenuBar',
        name: 'Cores de prova',
    },
    {
        id: 1106,
        label: 'Visualizar > Aviso de gamut',
        placement: 'MenuBar',
        name: 'Aviso de gamut',
    },
    {
        id: 1107,
        label: 'Editar > Copiar mesclado',
        placement: 'MenuBar',
        name: 'Copiar mesclado',
    },
    {
        id: 1108,
        label: 'Selecionar > Modificar > Suavização...',
        placement: 'MenuBar',
        name: 'Suavização...',
    },
    {
        id: 1109,
        label: 'Selecionar > Modificar > Expansão...',
        placement: 'MenuBar',
        name: 'Expansão...',
    },
    {
        id: 1110,
        label: 'Selecionar > Modificar > Contração...',
        placement: 'MenuBar',
        name: 'Contração...',
    },
    {
        id: 1111,
        label: 'Janela > Opções',
        placement: 'MenuBar',
        name: 'Opções',
    },
    {
        id: 1112,
        label: 'Visualizar > Correção de proporções de pixel',
        placement: 'MenuBar',
        name: 'Correção de proporções de pixel',
    },
    {
        id: 1114,
        label: 'Camada > Ocultar camadas',
        placement: 'MenuBar',
        name: 'Ocultar camadas',
    },
    {
        id: 1115,
        label: 'Selecionar > Selecionar e mascarar...',
        placement: 'MenuBar',
        name: 'Selecionar e mascarar...',
    },
    {
        id: 1119,
        label: 'Janela > Amostras',
        placement: 'MenuBar',
        name: 'Amostras',
    },
    {
        id: 1134,
        label: 'Imagem > Duplicar...',
        placement: 'MenuBar',
        name: 'Duplicar...',
    },
    {
        id: 1135,
        label: 'Camada > Duplicar camada...',
        placement: 'MenuBar',
        name: 'Duplicar camada...',
    },
    {
        id: 1137,
        label: 'Arquivo > Info sobre arquivo...',
        placement: 'MenuBar',
        name: 'Info sobre arquivo...',
    },
    {
        id: 1139,
        label: 'Camada > Mesclar camadas visíveis',
        placement: 'MenuBar',
        name: 'Mesclar camadas visíveis',
    },
    {
        id: 1141,
        label: 'Camada > Achatar imagem',
        placement: 'MenuBar',
        name: 'Achatar imagem',
    },
    {
        id: 1152,
        label: 'Selecionar > Intervalo de cores...',
        placement: 'MenuBar',
        name: 'Intervalo de cores...',
    },
    {
        id: 1153,
        label: 'Imagem > Aplicar imagem...',
        placement: 'MenuBar',
        name: 'Aplicar imagem...',
    },
    {
        id: 1154,
        label: 'Editar > Atenuar...',
        placement: 'MenuBar',
        name: 'Atenuar...',
    },
    {
        id: 1156,
        label: 'Camada > Máscara de camada > Ocultar todas',
        placement: 'MenuBar',
        name: 'Ocultar todas',
    },
    {
        id: 1157,
        label: 'Camada > Máscara de camada > Revelar todas',
        placement: 'MenuBar',
        name: 'Revelar todas',
    },
    {
        id: 1158,
        label: 'Camada > Máscara de camada > Revelar seleção',
        placement: 'MenuBar',
        name: 'Revelar seleção',
    },
    {
        id: 1159,
        label: 'Camada > Máscara de camada > Ativar',
        placement: 'MenuBar',
        name: 'Ativar',
    },
    {
        id: 1161,
        label: 'Imagem > Modo > 8 Bits/Canal',
        placement: 'MenuBar',
        name: '8 Bits/Canal',
    },
    {
        id: 1162,
        label: 'Imagem > Modo > 16 Bits/Canal',
        placement: 'MenuBar',
        name: '16 Bits/Canal',
    },
    {
        id: 1163,
        label: 'Janela > Navegador',
        placement: 'MenuBar',
        name: 'Navegador',
    },
    {
        id: 1166,
        label: 'Camada > Mesclar camadas',
        placement: 'MenuBar',
        name: 'Mesclar camadas',
    },
    {
        id: 1167,
        label: 'Janela > Composições de Camada',
        placement: 'MenuBar',
        name: 'Composições de Camada',
    },
    {
        id: 1168,
        label: 'Camada > Máscara de camada > Ocultar seleção',
        placement: 'MenuBar',
        name: 'Ocultar seleção',
    },
    {
        id: 1169,
        label: 'Arquivo > Automatizar > Criar Droplet...',
        placement: 'MenuBar',
        name: 'Criar Droplet...',
    },
    {
        id: 1170,
        label: 'Janela > Ações',
        placement: 'MenuBar',
        name: 'Ações',
    },
    {
        id: 1180,
        label: 'Arquivo > Automatizar > Lote...',
        placement: 'MenuBar',
        name: 'Lote...',
    },
    {
        id: 1188,
        label: 'Janela > Linha do Tempo',
        placement: 'MenuBar',
        name: 'Linha do Tempo',
    },
    {
        id: 1190,
        label: 'Visualizar > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: 'Visualizar > Tamanho da impressão',
        placement: 'MenuBar',
        name: 'Tamanho da impressão',
    },
    {
        id: 1192,
        label: 'Visualizar > Ajustas à tela',
        placement: 'MenuBar',
        name: 'Ajustas à tela',
    },
    {
        id: 1194,
        label: 'Janela > Ferramentas',
        placement: 'MenuBar',
        name: 'Ferramentas',
    },
    {
        id: 1195,
        label: 'Visualizar > Ajustar prancheta à tela',
        placement: 'MenuBar',
        name: 'Ajustar prancheta à tela',
    },
    {
        id: 1199,
        label: 'Janela > Histórico',
        placement: 'MenuBar',
        name: 'Histórico',
    },
    {
        id: 1200,
        label: 'Selecionar > Carregar seleção...',
        placement: 'MenuBar',
        name: 'Carregar seleção...',
    },
    {
        id: 1202,
        label: 'Visualizar > Proporções de pixel > Proporções de pixel personalizadas...',
        placement: 'MenuBar',
        name: 'Proporções de pixel personalizadas...',
    },
    {
        id: 1203,
        label: 'Visualizar > Proporções de pixel > Excluir proporções de pixel...',
        placement: 'MenuBar',
        name: 'Excluir proporções de pixel...',
    },
    {
        id: 1204,
        label: 'Visualizar > Proporções de pixel > Redefinir proporções de pixel...',
        placement: 'MenuBar',
        name: 'Redefinir proporções de pixel...',
    },
    {
        id: 1205,
        label: 'Visualizar > Proporções de pixel > Quadrado',
        placement: 'MenuBar',
        name: 'Quadrado',
    },
    {
        id: 1206,
        label: 'Imagem > Modo > 32 Bits/Canal',
        placement: 'MenuBar',
        name: '32 Bits/Canal',
    },
    {
        id: 1211,
        label: 'Editar > Predefinições > Migrar predefinições',
        placement: 'MenuBar',
        name: 'Migrar predefinições',
    },
    {
        id: 1212,
        label: 'Editar > Atribuir perfil...',
        placement: 'MenuBar',
        name: 'Atribuir perfil...',
    },
    {
        id: 1213,
        label: 'Editar > Converter para Perfil...',
        placement: 'MenuBar',
        name: 'Converter para Perfil...',
    },
    {
        id: 1214,
        label: 'Editar > Predefinições > Gerenciador de predefinição...',
        placement: 'MenuBar',
        name: 'Gerenciador de predefinição...',
    },
    {
        id: 1215,
        label: 'Editar > Predefinições do Adobe PDF...',
        placement: 'MenuBar',
        name: 'Predefinições do Adobe PDF...',
    },
    {
        id: 1217,
        label: 'Visualizar > Tamanho real',
        placement: 'MenuBar',
        name: 'Tamanho real',
    },
    {
        id: 1223,
        label: 'Texto > Orientação > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 1224,
        label: 'Texto > Orientação > Vertical',
        placement: 'MenuBar',
        name: 'Vertical',
    },
    {
        id: 1228,
        label: 'Texto > Criar demarcador de trabalho',
        placement: 'MenuBar',
        name: 'Criar demarcador de trabalho',
    },
    {
        id: 1229,
        label: 'Texto > Converter para forma',
        placement: 'MenuBar',
        name: 'Converter para forma',
    },
    {
        id: 1231,
        label: 'Camada > Alinhar > Arestas Superiores',
        placement: 'MenuBar',
        name: 'Arestas Superiores',
    },
    {
        id: 1232,
        label: 'Camada > Alinhar > Arestas Inferiores',
        placement: 'MenuBar',
        name: 'Arestas Inferiores',
    },
    {
        id: 1233,
        label: 'Camada > Alinhar > Centros Verticais',
        placement: 'MenuBar',
        name: 'Centros Verticais',
    },
    {
        id: 1234,
        label: 'Camada > Alinhar > Arestas à Esquerda',
        placement: 'MenuBar',
        name: 'Arestas à Esquerda',
    },
    {
        id: 1235,
        label: 'Camada > Alinhar > Arestas à Direita',
        placement: 'MenuBar',
        name: 'Arestas à Direita',
    },
    {
        id: 1236,
        label: 'Camada > Alinhar > Centros Horizontais',
        placement: 'MenuBar',
        name: 'Centros Horizontais',
    },
    {
        id: 1237,
        label: 'Editar > Alinhar camadas automaticamente...',
        placement: 'MenuBar',
        name: 'Alinhar camadas automaticamente...',
    },
    {
        id: 1238,
        label: 'Editar > Mesclar camadas automaticamente...',
        placement: 'MenuBar',
        name: 'Mesclar camadas automaticamente...',
    },
    {
        id: 1239,
        label: 'Camada > Distribuir > Verticalmente',
        placement: 'MenuBar',
        name: 'Verticalmente',
    },
    {
        id: 1241,
        label: 'Camada > Distribuir > Arestas Superiores',
        placement: 'MenuBar',
        name: 'Arestas Superiores',
    },
    {
        id: 1242,
        label: 'Camada > Distribuir > Arestas Inferiores',
        placement: 'MenuBar',
        name: 'Arestas Inferiores',
    },
    {
        id: 1243,
        label: 'Camada > Distribuir > Centros Verticais',
        placement: 'MenuBar',
        name: 'Centros Verticais',
    },
    {
        id: 1245,
        label: 'Camada > Distribuir > Arestas à Esquerda',
        placement: 'MenuBar',
        name: 'Arestas à Esquerda',
    },
    {
        id: 1246,
        label: 'Camada > Distribuir > Arestas à Direita',
        placement: 'MenuBar',
        name: 'Arestas à Direita',
    },
    {
        id: 1247,
        label: 'Camada > Distribuir > Centros Horizontais',
        placement: 'MenuBar',
        name: 'Centros Horizontais',
    },
    {
        id: 1249,
        label: 'Camada > Distribuir > Horizontalmente',
        placement: 'MenuBar',
        name: 'Horizontalmente',
    },
    {
        id: 1281,
        label: 'Selecionar > Salvar seleção...',
        placement: 'MenuBar',
        name: 'Salvar seleção...',
    },
    {
        id: 1284,
        label: 'Visualizar > Virar horizontalmente',
        placement: 'MenuBar',
        name: 'Virar horizontalmente',
    },
    {
        id: 1285,
        label: 'Visualizar > Visualização de padrão',
        placement: 'MenuBar',
        name: 'Visualização de padrão',
    },
    {
        id: 1292,
        label: 'Camada > Máscara de camada > De transparência',
        placement: 'MenuBar',
        name: 'De transparência',
    },
    {
        id: 1295,
        label: 'Camada > Reflexão da luz > Descontaminação de cores...',
        placement: 'MenuBar',
        name: 'Descontaminação de cores...',
    },
    {
        id: 1297,
        label: 'Editar > Colar especial > Colar no local',
        placement: 'MenuBar',
        name: 'Colar no local',
    },
    {
        id: 1299,
        label: 'Visualizar > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: 'Camada > Estilo de camada > Sombra projetada...',
        placement: 'MenuBar',
        name: 'Sombra projetada...',
    },
    {
        id: 1302,
        label: 'Camada > Estilo de camada > Sombra interna...',
        placement: 'MenuBar',
        name: 'Sombra interna...',
    },
    {
        id: 1303,
        label: 'Camada > Estilo de camada > Brilho externo...',
        placement: 'MenuBar',
        name: 'Brilho externo...',
    },
    {
        id: 1304,
        label: 'Camada > Estilo de camada > Brilho interno...',
        placement: 'MenuBar',
        name: 'Brilho interno...',
    },
    {
        id: 1305,
        label: 'Camada > Estilo de camada > Chanfro & Entalhe...',
        placement: 'MenuBar',
        name: 'Chanfro & Entalhe...',
    },
    {
        id: 1306,
        label: 'Camada > Estilo de camada > Ocultar todos os efeitos',
        placement: 'MenuBar',
        name: 'Ocultar todos os efeitos',
    },
    {
        id: 1307,
        label: 'Camada > Estilo de camada > Luz global...',
        placement: 'MenuBar',
        name: 'Luz global...',
    },
    {
        id: 1308,
        label: 'Camada > Estilo de camada > Criar Camadas',
        placement: 'MenuBar',
        name: 'Criar Camadas',
    },
    {
        id: 1312,
        label: 'Camada > Estilo de camada > Acetinado...',
        placement: 'MenuBar',
        name: 'Acetinado...',
    },
    {
        id: 1313,
        label: 'Camada > Estilo de camada > Traçado...',
        placement: 'MenuBar',
        name: 'Traçado...',
    },
    {
        id: 1314,
        label: 'Camada > Estilo de camada > Copiar estilo de camada',
        placement: 'MenuBar',
        name: 'Copiar estilo de camada',
    },
    {
        id: 1315,
        label: 'Camada > Estilo de camada > Colar estilo de camada',
        placement: 'MenuBar',
        name: 'Colar estilo de camada',
    },
    {
        id: 1327,
        label: 'Camada > Estilo de camada > Redimensionar efeitos...',
        placement: 'MenuBar',
        name: 'Redimensionar efeitos...',
    },
    {
        id: 1331,
        label: 'Camada > Estilo de camada > Opções de mesclagem...',
        placement: 'MenuBar',
        name: 'Opções de mesclagem...',
    },
    {
        id: 1335,
        label: 'Camada > Estilo de camada > Sobreposição de cor...',
        placement: 'MenuBar',
        name: 'Sobreposição de cor...',
    },
    {
        id: 1336,
        label: 'Camada > Estilo de camada > Sobreposição de degradê...',
        placement: 'MenuBar',
        name: 'Sobreposição de degradê...',
    },
    {
        id: 1337,
        label: 'Camada > Estilo de camada > Sobreposição de padrão...',
        placement: 'MenuBar',
        name: 'Sobreposição de padrão...',
    },
    {
        id: 1339,
        label: 'Camada > Estilo de camada > Apagar estilo de camada',
        placement: 'MenuBar',
        name: 'Apagar estilo de camada',
    },
    {
        id: 1355,
        label: 'Janela > Notas',
        placement: 'MenuBar',
        name: 'Notas',
    },
    {
        id: 1382,
        label: 'Janela > Histograma',
        placement: 'MenuBar',
        name: 'Histograma',
    },
    {
        id: 1396,
        label: 'Janela > Pincéis',
        placement: 'MenuBar',
        name: 'Pincéis',
    },
    {
        id: 1429,
        label: 'Plug-ins > Painel de plug-ins',
        placement: 'MenuBar',
        name: 'Painel de plug-ins',
    },
    {
        id: 1430,
        label: 'Plug-ins > Procurar plug-ins...',
        placement: 'MenuBar',
        name: 'Procurar plug-ins...',
    },
    {
        id: 1431,
        label: 'Plug-ins > Gerenciar plug-ins...',
        placement: 'MenuBar',
        name: 'Gerenciar plug-ins...',
    },
    {
        id: 1460,
        label: 'Selecionar > Área de foco…',
        placement: 'MenuBar',
        name: 'Área de foco…',
    },
    {
        id: 1461,
        label: 'Selecionar > Assunto',
        placement: 'MenuBar',
        name: 'Assunto',
    },
    {
        id: 1462,
        label: 'Selecionar > Céu',
        placement: 'MenuBar',
        name: 'Céu',
    },
    {
        id: 1502,
        label: 'Arquivo > Importar > Imagens do dispositivo...',
        placement: 'MenuBar',
        name: 'Imagens do dispositivo...',
    },
    {
        id: 1503,
        label: 'Arquivo > Importar do iPhone ou iPad',
        placement: 'MenuBar',
        name: 'Importar do iPhone ou iPad',
    },
    {
        id: 1510,
        label: 'Editar > Preenchimento sensível ao conteúdo...',
        placement: 'MenuBar',
        name: 'Preenchimento sensível ao conteúdo...',
    },
    {
        id: 1520,
        label: 'Arquivo > Procurar no Bridge...',
        placement: 'MenuBar',
        name: 'Procurar no Bridge...',
    },
    {
        id: 1522,
        label: 'Texto > Veja mais em Adobe Fonts...',
        placement: 'MenuBar',
        name: 'Veja mais em Adobe Fonts...',
    },
    {
        id: 1530,
        label: 'Arquivo > Fechar e ir para o Bridge...',
        placement: 'MenuBar',
        name: 'Fechar e ir para o Bridge...',
    },
    {
        id: 1613,
        label: 'Editar > Conexões remotas...',
        placement: 'MenuBar',
        name: 'Conexões remotas...',
    },
    {
        id: 1676,
        label: 'Arquivo > Scripts > Procurar...',
        placement: 'MenuBar',
        name: 'Procurar...',
    },
    {
        id: 1695,
        label: 'Arquivo > Exportar > Salvar para Web...',
        placement: 'MenuBar',
        name: 'Salvar para Web...',
    },
    {
        id: 1696,
        label: 'Arquivo > Automatizar > Apresentação de PDF...',
        placement: 'MenuBar',
        name: 'Apresentação de PDF...',
    },
    {
        id: 1701,
        label: 'Imagem > Ajustes > Inverter',
        placement: 'MenuBar',
        name: 'Inverter',
    },
    {
        id: 1702,
        label: 'Imagem > Ajustes > Equalizar',
        placement: 'MenuBar',
        name: 'Equalizar',
    },
    {
        id: 1703,
        label: 'Imagem > Ajustes > Limiar...',
        placement: 'MenuBar',
        name: 'Limiar...',
    },
    {
        id: 1704,
        label: 'Imagem > Ajustes > Posterizar...',
        placement: 'MenuBar',
        name: 'Posterizar...',
    },
    {
        id: 1750,
        label: 'Editar > Preenchimento generativo...',
        placement: 'MenuBar',
        name: 'Preenchimento generativo...',
    },
    {
        id: 1771,
        label: 'Editar > Gerar imagem...',
        placement: 'MenuBar',
        name: 'Gerar imagem...',
    },
    {
        id: 1776,
        label: 'Imagem > Aprimoramento generativo...',
        placement: 'MenuBar',
        name: 'Aprimoramento generativo...',
    },
    {
        id: 1777,
        label: 'Filtro > AI Denoise...',
        placement: 'MenuBar',
        name: 'AI Denoise...',
    },
    {
        id: 1778,
        label: 'Filtro > Nitidez com IA…',
        placement: 'MenuBar',
        name: 'Nitidez com IA…',
    },
    {
        id: 1801,
        label: 'Imagem > Ajustes > Níveis...',
        placement: 'MenuBar',
        name: 'Níveis...',
    },
    {
        id: 1802,
        label: 'Imagem > Ajustes > Curvas...',
        placement: 'MenuBar',
        name: 'Curvas...',
    },
    {
        id: 1803,
        label: 'Imagem > Ajustes > Brilho/Contraste...',
        placement: 'MenuBar',
        name: 'Brilho/Contraste...',
    },
    {
        id: 1804,
        label: 'Imagem > Ajustes > Equilíbrio de cores...',
        placement: 'MenuBar',
        name: 'Equilíbrio de cores...',
    },
    {
        id: 1805,
        label: 'Imagem > Ajustes > Matiz/Saturação...',
        placement: 'MenuBar',
        name: 'Matiz/Saturação...',
    },
    {
        id: 1806,
        label: 'Imagem > Ajustes > Substituir cor...',
        placement: 'MenuBar',
        name: 'Substituir cor...',
    },
    {
        id: 1807,
        label: 'Imagem > Ajustes > Cor seletiva...',
        placement: 'MenuBar',
        name: 'Cor seletiva...',
    },
    {
        id: 1808,
        label: 'Imagem > Tom automático',
        placement: 'MenuBar',
        name: 'Tom automático',
    },
    {
        id: 1809,
        label: 'Imagem > Ajustes > Remover saturação',
        placement: 'MenuBar',
        name: 'Remover saturação',
    },
    {
        id: 1810,
        label: 'Imagem > Contraste automático',
        placement: 'MenuBar',
        name: 'Contraste automático',
    },
    {
        id: 1817,
        label: 'Imagem > Cor automática',
        placement: 'MenuBar',
        name: 'Cor automática',
    },
    {
        id: 1822,
        label: 'Imagem > Ajustes > Corresponder cor...',
        placement: 'MenuBar',
        name: 'Corresponder cor...',
    },
    {
        id: 1824,
        label: 'Imagem > Ajustes > Preto-e-branco...',
        placement: 'MenuBar',
        name: 'Preto-e-branco...',
    },
    {
        id: 1827,
        label: 'Imagem > Ajustes > Vibração...',
        placement: 'MenuBar',
        name: 'Vibração...',
    },
    {
        id: 1900,
        label: 'Imagem > Cálculos...',
        placement: 'MenuBar',
        name: 'Cálculos...',
    },
    {
        id: 1942,
        label: 'Camada > Nova > Plano de Fundo',
        placement: 'MenuBar',
        name: 'Plano de Fundo',
    },
    {
        id: 1943,
        label: 'Selecionar > Selecionar novamente',
        placement: 'MenuBar',
        name: 'Selecionar novamente',
    },
    {
        id: 1953,
        label: 'Camada > Máscara de vetor > Ocultar todas',
        placement: 'MenuBar',
        name: 'Ocultar todas',
    },
    {
        id: 1954,
        label: 'Camada > Máscara de vetor > Revelar todas',
        placement: 'MenuBar',
        name: 'Revelar todas',
    },
    {
        id: 1955,
        label: 'Camada > Máscara de vetor > Demarcador atual',
        placement: 'MenuBar',
        name: 'Demarcador atual',
    },
    {
        id: 1956,
        label: 'Camada > Máscara de vetor > Excluir',
        placement: 'MenuBar',
        name: 'Excluir',
    },
    {
        id: 1957,
        label: 'Camada > Rasterizar > Máscara de vetor',
        placement: 'MenuBar',
        name: 'Máscara de vetor',
    },
    {
        id: 1959,
        label: 'Camada > Máscara de vetor > Ativar',
        placement: 'MenuBar',
        name: 'Ativar',
    },
    {
        id: 1971,
        label: 'Selecionar > Transformar seleção',
        placement: 'MenuBar',
        name: 'Transformar seleção',
    },
    {
        id: 2101,
        label: 'Arquivo > Imprimir...',
        placement: 'MenuBar',
        name: 'Imprimir...',
    },
    {
        id: 2103,
        label: 'Arquivo > Abrir recentes > Apagar lista de arquivos recentes',
        placement: 'MenuBar',
        name: 'Apagar lista de arquivos recentes',
    },
    {
        id: 2109,
        label: 'Camada > Máscara de vetor > Vincular',
        placement: 'MenuBar',
        name: 'Vincular',
    },
    {
        id: 2201,
        label: 'Editar > Transformação > Redimensionar',
        placement: 'MenuBar',
        name: 'Redimensionar',
    },
    {
        id: 2202,
        label: 'Editar > Transformação > Inclinar',
        placement: 'MenuBar',
        name: 'Inclinar',
    },
    {
        id: 2203,
        label: 'Editar > Transformação > Perspectiva',
        placement: 'MenuBar',
        name: 'Perspectiva',
    },
    {
        id: 2204,
        label: 'Editar > Transformação > Distorcer',
        placement: 'MenuBar',
        name: 'Distorcer',
    },
    {
        id: 2205,
        label: 'Editar > Transformação > Girar',
        placement: 'MenuBar',
        name: 'Girar',
    },
    {
        id: 2207,
        label: 'Editar > Transformação Livre',
        placement: 'MenuBar',
        name: 'Transformação Livre',
    },
    {
        id: 2208,
        label: 'Editar > Transformação > Girar 180°',
        placement: 'MenuBar',
        name: 'Girar 180°',
    },
    {
        id: 2209,
        label: 'Editar > Transformação > Girar 90° em sentido horário',
        placement: 'MenuBar',
        name: 'Girar 90° em sentido horário',
    },
    {
        id: 2210,
        label: 'Editar > Transformação > Girar 90° em sentido anti-horário',
        placement: 'MenuBar',
        name: 'Girar 90° em sentido anti-horário',
    },
    {
        id: 2211,
        label: 'Editar > Transformação > Virar horizontalmente',
        placement: 'MenuBar',
        name: 'Virar horizontalmente',
    },
    {
        id: 2212,
        label: 'Editar > Transformação > Virar verticalmente',
        placement: 'MenuBar',
        name: 'Virar verticalmente',
    },
    {
        id: 2217,
        label: 'Editar > Transformação > Novamente',
        placement: 'MenuBar',
        name: 'Novamente',
    },
    {
        id: 2218,
        label: 'Texto > Distorcer texto...',
        placement: 'MenuBar',
        name: 'Distorcer texto...',
    },
    {
        id: 2219,
        label: 'Editar > Transformação > Deformar',
        placement: 'MenuBar',
        name: 'Deformar',
    },
    {
        id: 2220,
        label: 'Editar > Escala sensível a conteúdo',
        placement: 'MenuBar',
        name: 'Escala sensível a conteúdo',
    },
    {
        id: 2221,
        label: 'Editar > Distorção de marionete',
        placement: 'MenuBar',
        name: 'Distorção de marionete',
    },
    {
        id: 2224,
        label: 'Filtro > Galeria de desfoques > Desfoque da íris...',
        placement: 'MenuBar',
        name: 'Desfoque da íris...',
    },
    {
        id: 2225,
        label: 'Filtro > Galeria de desfoques > Desfoque de campo...',
        placement: 'MenuBar',
        name: 'Desfoque de campo...',
    },
    {
        id: 2226,
        label: 'Filtro > Galeria de desfoques > Mudança de inclinação...',
        placement: 'MenuBar',
        name: 'Mudança de inclinação...',
    },
    {
        id: 2227,
        label: 'Filtro > Galeria de desfoques > Desfoque direcional...',
        placement: 'MenuBar',
        name: 'Desfoque direcional...',
    },
    {
        id: 2229,
        label: 'Filtro > Galeria de desfoques > Desfoque de giro...',
        placement: 'MenuBar',
        name: 'Desfoque de giro...',
    },
    {
        id: 2231,
        label: 'Filtro > Renderização > Chama…',
        placement: 'MenuBar',
        name: 'Chama…',
    },
    {
        id: 2232,
        label: 'Filtro > Renderização > Moldura de imagem...',
        placement: 'MenuBar',
        name: 'Moldura de imagem...',
    },
    {
        id: 2233,
        label: 'Filtro > Renderização > Árvore...',
        placement: 'MenuBar',
        name: 'Árvore...',
    },
    {
        id: 2250,
        label: 'Editar > Transformação > Dividir distorção horizontalmente',
        placement: 'MenuBar',
        name: 'Dividir distorção horizontalmente',
    },
    {
        id: 2251,
        label: 'Editar > Transformação > Dividir distorção verticalmente',
        placement: 'MenuBar',
        name: 'Dividir distorção verticalmente',
    },
    {
        id: 2252,
        label: 'Editar > Transformação > Dividir distorção transversalmente',
        placement: 'MenuBar',
        name: 'Dividir distorção transversalmente',
    },
    {
        id: 2253,
        label: 'Editar > Transformação > Remover divisão de distorção',
        placement: 'MenuBar',
        name: 'Remover divisão de distorção',
    },
    {
        id: 2254,
        label: 'Editar > Transformação > Alternar Guias',
        placement: 'MenuBar',
        name: 'Alternar Guias',
    },
    {
        id: 2255,
        label: 'Editar > Transformação > Conv. âncora de distorção',
        placement: 'MenuBar',
        name: 'Conv. âncora de distorção',
    },
    {
        id: 2260,
        label: 'Editar > Substituição do céu...',
        placement: 'MenuBar',
        name: 'Substituição do céu...',
    },
    {
        id: 2304,
        label: 'Photoshop > Preferências > Desempenho...',
        placement: 'MenuBar',
        name: 'Desempenho...',
    },
    {
        id: 2311,
        label: 'Photoshop > Preferências > Geral...',
        placement: 'MenuBar',
        name: 'Geral...',
    },
    {
        id: 2312,
        label: 'Photoshop > Preferências > Cursores...',
        placement: 'MenuBar',
        name: 'Cursores...',
    },
    {
        id: 2313,
        label: 'Photoshop > Preferências > Transparência e Gamut...',
        placement: 'MenuBar',
        name: 'Transparência e Gamut...',
    },
    {
        id: 2314,
        label: 'Photoshop > Preferências > Unidades e réguas...',
        placement: 'MenuBar',
        name: 'Unidades e réguas...',
    },
    {
        id: 2315,
        label: 'Photoshop > Preferências > Guias, grade e fatias...',
        placement: 'MenuBar',
        name: 'Guias, grade e fatias...',
    },
    {
        id: 2316,
        label: 'Photoshop > Preferências > Plug-ins...',
        placement: 'MenuBar',
        name: 'Plug-ins...',
    },
    {
        id: 2317,
        label: 'Photoshop > Preferências > Controle de arquivo...',
        placement: 'MenuBar',
        name: 'Controle de arquivo...',
    },
    {
        id: 2322,
        label: 'Photoshop > Preferências > Texto...',
        placement: 'MenuBar',
        name: 'Texto...',
    },
    {
        id: 2323,
        label: 'Photoshop > Preferências > Interface...',
        placement: 'MenuBar',
        name: 'Interface...',
    },
    {
        id: 2324,
        label: 'Photoshop > Preferências > Camera Raw...',
        placement: 'MenuBar',
        name: 'Camera Raw...',
    },
    {
        id: 2327,
        label: 'Photoshop > Preferências > Visualizações de tecnologia…',
        placement: 'MenuBar',
        name: 'Visualizações de tecnologia…',
    },
    {
        id: 2328,
        label: 'Photoshop > Preferências > Discos de Trabalho...',
        placement: 'MenuBar',
        name: 'Discos de Trabalho...',
    },
    {
        id: 2329,
        label: 'Photoshop > Preferências > Histórico e Content Credentials...',
        placement: 'MenuBar',
        name: 'Histórico e Content Credentials...',
    },
    {
        id: 2330,
        label: 'Photoshop > Preferências > Ferramentas...',
        placement: 'MenuBar',
        name: 'Ferramentas...',
    },
    {
        id: 2331,
        label: 'Photoshop > Preferências > Área de Trabalho...',
        placement: 'MenuBar',
        name: 'Área de Trabalho...',
    },
    {
        id: 2332,
        label: 'Photoshop > Preferências > Exportar...',
        placement: 'MenuBar',
        name: 'Exportar...',
    },
    {
        id: 2332,
        label: 'Arquivo > Exportar > Preferências de exportação...',
        placement: 'MenuBar',
        name: 'Preferências de exportação...',
    },
    {
        id: 2333,
        label: 'Photoshop > Preferências > Controles aprimorados...',
        placement: 'MenuBar',
        name: 'Controles aprimorados...',
    },
    {
        id: 2335,
        label: 'Photoshop > Preferências > Processamento de imagem...',
        placement: 'MenuBar',
        name: 'Processamento de imagem...',
    },
    {
        id: 2337,
        label: 'Photoshop > Preferências > Notificações...',
        placement: 'MenuBar',
        name: 'Notificações...',
    },
    {
        id: 2344,
        label: 'Editar > Configurações de cores...',
        placement: 'MenuBar',
        name: 'Configurações de cores...',
    },
    {
        id: 2345,
        label: 'Editar > Configurações de OpenColorIO...',
        placement: 'MenuBar',
        name: 'Configurações de OpenColorIO...',
    },
    {
        id: 2361,
        label: 'Editar > Descartar > Históricos',
        placement: 'MenuBar',
        name: 'Históricos',
    },
    {
        id: 2701,
        label: 'Camada > Reflexão da luz > Remover Preto Fosco',
        placement: 'MenuBar',
        name: 'Remover Preto Fosco',
    },
    {
        id: 2703,
        label: 'Camada > Reflexão da luz > Remover Branco Fosco',
        placement: 'MenuBar',
        name: 'Remover Branco Fosco',
    },
    {
        id: 2711,
        label: 'Camada > Organizar > Trazer para o primeiro plano',
        placement: 'MenuBar',
        name: 'Trazer para o primeiro plano',
    },
    {
        id: 2712,
        label: 'Camada > Organizar > Trazer para Frente',
        placement: 'MenuBar',
        name: 'Trazer para Frente',
    },
    {
        id: 2713,
        label: 'Camada > Organizar > Enviar para trás',
        placement: 'MenuBar',
        name: 'Enviar para trás',
    },
    {
        id: 2714,
        label: 'Camada > Organizar > Enviar para o plano de fundo',
        placement: 'MenuBar',
        name: 'Enviar para o plano de fundo',
    },
    {
        id: 2715,
        label: 'Camada > Organizar > Inverter',
        placement: 'MenuBar',
        name: 'Inverter',
    },
    {
        id: 2769,
        label: 'Camada > Filtro inteligente > Desativar Filtros Inteligentes',
        placement: 'MenuBar',
        name: 'Desativar Filtros Inteligentes',
    },
    {
        id: 2770,
        label: 'Camada > Filtro inteligente > Apagar Filtros Inteligentes',
        placement: 'MenuBar',
        name: 'Apagar Filtros Inteligentes',
    },
    {
        id: 2802,
        label: 'Visualizar > Configuração de prova > Personalizada...',
        placement: 'MenuBar',
        name: 'Personalizada...',
    },
    {
        id: 2803,
        label: 'Visualizar > Configuração de prova > CMYK ativo',
        placement: 'MenuBar',
        name: 'CMYK ativo',
    },
    {
        id: 2804,
        label: 'Visualizar > Configuração de prova > Chapa de ciano ativo',
        placement: 'MenuBar',
        name: 'Chapa de ciano ativo',
    },
    {
        id: 2805,
        label: 'Visualizar > Configuração de prova > Chapa de magenta ativo',
        placement: 'MenuBar',
        name: 'Chapa de magenta ativo',
    },
    {
        id: 2806,
        label: 'Visualizar > Configuração de prova > Chapa de amarelo ativo',
        placement: 'MenuBar',
        name: 'Chapa de amarelo ativo',
    },
    {
        id: 2807,
        label: 'Visualizar > Configuração de prova > Chapa de preto ativo',
        placement: 'MenuBar',
        name: 'Chapa de preto ativo',
    },
    {
        id: 2808,
        label: 'Visualizar > Configuração de prova > Chapa de CMY ativo',
        placement: 'MenuBar',
        name: 'Chapa de CMY ativo',
    },
    {
        id: 2809,
        label: 'Visualizar > Configuração de prova > RGB existente do Macintosh (Gama 1.8)',
        placement: 'MenuBar',
        name: 'RGB existente do Macintosh (Gama 1.8)',
    },
    {
        id: 2810,
        label: 'Visualizar > Configuração de prova > RGB padrão da internet (sRGB)',
        placement: 'MenuBar',
        name: 'RGB padrão da internet (sRGB)',
    },
    {
        id: 2811,
        label: 'Visualizar > Configuração de prova > RGB do monitor',
        placement: 'MenuBar',
        name: 'RGB do monitor',
    },
    {
        id: 2815,
        label: 'Visualizar > Configuração de prova > Deficiência de cor – tipo protanopia',
        placement: 'MenuBar',
        name: 'Deficiência de cor – tipo protanopia',
    },
    {
        id: 2816,
        label: 'Visualizar > Configuração de prova > Deficiência de cor – tipo deuteranopia',
        placement: 'MenuBar',
        name: 'Deficiência de cor – tipo deuteranopia',
    },
    {
        id: 2820,
        label: 'Imagem > Análise > Ferramenta régua',
        placement: 'MenuBar',
        name: 'Ferramenta régua',
    },
    {
        id: 2830,
        label: 'Imagem > Análise > Inserir marcador de escala...',
        placement: 'MenuBar',
        name: 'Inserir marcador de escala...',
    },
    {
        id: 2841,
        label: 'Imagem > Análise > Definir escala de medida > Padrão',
        placement: 'MenuBar',
        name: 'Padrão',
    },
    {
        id: 2842,
        label: 'Imagem > Análise > Definir escala de medida > Personalizar...',
        placement: 'MenuBar',
        name: 'Personalizar...',
    },
    {
        id: 2851,
        label: 'Imagem > Análise > Selecionar pontos de dados > Personalizar...',
        placement: 'MenuBar',
        name: 'Personalizar...',
    },
    {
        id: 2860,
        label: 'Imagem > Análise > Gravar Medidas',
        placement: 'MenuBar',
        name: 'Gravar Medidas',
    },
    {
        id: 2880,
        label: 'Janela > Registro de Medida',
        placement: 'MenuBar',
        name: 'Registro de Medida',
    },
    {
        id: 2912,
        label: 'Editar > Descartar > Área de transferência',
        placement: 'MenuBar',
        name: 'Área de transferência',
    },
    {
        id: 2915,
        label: 'Editar > Descartar > Tudo',
        placement: 'MenuBar',
        name: 'Tudo',
    },
    {
        id: 2920,
        label: 'Editar > Descartar > Cache de vídeo',
        placement: 'MenuBar',
        name: 'Cache de vídeo',
    },
    {
        id: 2939,
        label: 'Janela > Área de Trabalho > Bloquear área de trabalho',
        placement: 'MenuBar',
        name: 'Bloquear área de trabalho',
    },
    {
        id: 2940,
        label: 'Visualizar > Guias > Bloquear Guias',
        placement: 'MenuBar',
        name: 'Bloquear Guias',
    },
    {
        id: 2950,
        label: 'Visualizar > Guias > Apagar Guias',
        placement: 'MenuBar',
        name: 'Apagar Guias',
    },
    {
        id: 2951,
        label: 'Camada > Excluir > Camadas ocultas',
        placement: 'MenuBar',
        name: 'Camadas ocultas',
    },
    {
        id: 2952,
        label: 'Visualizar > Guias > Apagar guias da prancheta selecionada',
        placement: 'MenuBar',
        name: 'Apagar guias da prancheta selecionada',
    },
    {
        id: 2953,
        label: 'Visualizar > Guias > Apagar guias da tela de pintura',
        placement: 'MenuBar',
        name: 'Apagar guias da tela de pintura',
    },
    {
        id: 2956,
        label: 'Camada > Nova > Grupo a partir de Camadas...',
        placement: 'MenuBar',
        name: 'Grupo a partir de Camadas...',
    },
    {
        id: 2957,
        label: 'Camada > Bloquear camadas...',
        placement: 'MenuBar',
        name: 'Bloquear camadas...',
    },
    {
        id: 2958,
        label: 'Camada > Agrupar camadas',
        placement: 'MenuBar',
        name: 'Agrupar camadas',
    },
    {
        id: 2959,
        label: 'Camada > Desagrupar camadas',
        placement: 'MenuBar',
        name: 'Desagrupar camadas',
    },
    {
        id: 2960,
        label: 'Camada > Selecionar camadas vinculadas',
        placement: 'MenuBar',
        name: 'Selecionar camadas vinculadas',
    },
    {
        id: 2961,
        label: 'Camada > Vincular camadas',
        placement: 'MenuBar',
        name: 'Vincular camadas',
    },
    {
        id: 2962,
        label: 'Selecionar > Todas as camadas',
        placement: 'MenuBar',
        name: 'Todas as camadas',
    },
    {
        id: 2963,
        label: 'Selecionar > Cancelar seleção de camadas',
        placement: 'MenuBar',
        name: 'Cancelar seleção de camadas',
    },
    {
        id: 2967,
        label: 'Visualizar > Bloquear fatias',
        placement: 'MenuBar',
        name: 'Bloquear fatias',
    },
    {
        id: 2969,
        label: 'Visualizar > Apagar fatias',
        placement: 'MenuBar',
        name: 'Apagar fatias',
    },
    {
        id: 2970,
        label: 'Camada > Nova > Camada por Cópia',
        placement: 'MenuBar',
        name: 'Camada por Cópia',
    },
    {
        id: 2971,
        label: 'Camada > Nova > Camada por Corte',
        placement: 'MenuBar',
        name: 'Camada por Corte',
    },
    {
        id: 2972,
        label: 'Camada > Criar máscara de corte',
        placement: 'MenuBar',
        name: 'Criar máscara de corte',
    },
    {
        id: 2976,
        label: 'Camada > Nova > Agrupar...',
        placement: 'MenuBar',
        name: 'Agrupar...',
    },
    {
        id: 2980,
        label: 'Camada > Objetos inteligentes > Converter em objeto inteligente',
        placement: 'MenuBar',
        name: 'Converter em objeto inteligente',
    },
    {
        id: 2981,
        label: 'Camada > Objetos inteligentes > Novo objeto inteligente por cópia',
        placement: 'MenuBar',
        name: 'Novo objeto inteligente por cópia',
    },
    {
        id: 2982,
        label: 'Selecionar > Localizar camadas',
        placement: 'MenuBar',
        name: 'Localizar camadas',
    },
    {
        id: 2983,
        label: 'Camada > Renomear camada...',
        placement: 'MenuBar',
        name: 'Renomear camada...',
    },
    {
        id: 2986,
        label: 'Selecionar > Isolar camadas',
        placement: 'MenuBar',
        name: 'Isolar camadas',
    },
    {
        id: 2991,
        label: 'Imagem > Rotação de imagem > 90° em sentido horário',
        placement: 'MenuBar',
        name: '90° em sentido horário',
    },
    {
        id: 2992,
        label: 'Imagem > Rotação de imagem > 90° em sentido anti-horário',
        placement: 'MenuBar',
        name: '90° em sentido anti-horário',
    },
    {
        id: 2993,
        label: 'Imagem > Rotação de imagem > 180°',
        placement: 'MenuBar',
        name: '180°',
    },
    {
        id: 2994,
        label: 'Imagem > Rotação de imagem > Arbitrário...',
        placement: 'MenuBar',
        name: 'Arbitrário...',
    },
    {
        id: 2996,
        label: 'Imagem > Rotação de imagem > Virar tela de pintura horizontalmente',
        placement: 'MenuBar',
        name: 'Virar tela de pintura horizontalmente',
    },
    {
        id: 2997,
        label: 'Imagem > Rotação de imagem > Virar tela de pintura verticalmente',
        placement: 'MenuBar',
        name: 'Virar tela de pintura verticalmente',
    },
    {
        id: 3056,
        label: 'Imagem > Ajustes > Misturador de canais...',
        placement: 'MenuBar',
        name: 'Misturador de canais...',
    },
    {
        id: 3062,
        label: 'Imagem > Ajustes > Mapa de degradê...',
        placement: 'MenuBar',
        name: 'Mapa de degradê...',
    },
    {
        id: 3063,
        label: 'Imagem > Ajustes > Filtro de fotos...',
        placement: 'MenuBar',
        name: 'Filtro de fotos...',
    },
    {
        id: 3065,
        label: 'Imagem > Ajustes > Sombras/Realces...',
        placement: 'MenuBar',
        name: 'Sombras/Realces...',
    },
    {
        id: 3066,
        label: 'Imagem > Ajustes > Pesquisa de cores...',
        placement: 'MenuBar',
        name: 'Pesquisa de cores...',
    },
    {
        id: 3067,
        label: 'Imagem > Ajustes > Exposição...',
        placement: 'MenuBar',
        name: 'Exposição...',
    },
    {
        id: 3076,
        label: 'Camada > Filtro inteligente > Desativar Máscara de Filtro',
        placement: 'MenuBar',
        name: 'Desativar Máscara de Filtro',
    },
    {
        id: 3083,
        label: 'Camada > Nova camada de ajuste > Exposição...',
        placement: 'MenuBar',
        name: 'Exposição...',
    },
    {
        id: 3085,
        label: 'Camada > Nova camada de ajuste > Cor e vibração...',
        placement: 'MenuBar',
        name: 'Cor e vibração...',
    },
    {
        id: 3090,
        label: 'Arquivo > Colocar vinculados...',
        placement: 'MenuBar',
        name: 'Colocar vinculados...',
    },
    {
        id: 3091,
        label: 'Camada > Objetos inteligentes > Revelar no Finder',
        placement: 'MenuBar',
        name: 'Revelar no Finder',
    },
    {
        id: 3092,
        label: 'Arquivo > Pacote…',
        placement: 'MenuBar',
        name: 'Pacote…',
    },
    {
        id: 3098,
        label: 'Arquivo > Automatizar > Plug-ins geradores',
        placement: 'MenuBar',
        name: 'Plug-ins geradores',
    },
    {
        id: 3187,
        label: 'Janela > Estilos',
        placement: 'MenuBar',
        name: 'Estilos',
    },
    {
        id: 3300,
        label: 'Texto > Painéis > Painel de caracteres',
        placement: 'MenuBar',
        name: 'Painel de caracteres',
    },
    {
        id: 3300,
        label: 'Janela > Caractere',
        placement: 'MenuBar',
        name: 'Caractere',
    },
    {
        id: 3309,
        label: 'Texto > OpenType > Substituições Padrão',
        placement: 'MenuBar',
        name: 'Substituições Padrão',
    },
    {
        id: 3310,
        label: 'Texto > OpenType > Estilo antigo',
        placement: 'MenuBar',
        name: 'Estilo antigo',
    },
    {
        id: 3327,
        label: 'Texto > OpenType > Métrica Proporcional',
        placement: 'MenuBar',
        name: 'Métrica Proporcional',
    },
    {
        id: 3334,
        label: 'Texto > OpenType > Ornamental',
        placement: 'MenuBar',
        name: 'Ornamental',
    },
    {
        id: 3338,
        label: 'Texto > OpenType > Alternativas Contextuais',
        placement: 'MenuBar',
        name: 'Alternativas Contextuais',
    },
    {
        id: 3339,
        label: 'Texto > OpenType > Substituições Discriminadas',
        placement: 'MenuBar',
        name: 'Substituições Discriminadas',
    },
    {
        id: 3340,
        label: 'Texto > OpenType > Alternativas Estilísticas',
        placement: 'MenuBar',
        name: 'Alternativas Estilísticas',
    },
    {
        id: 3341,
        label: 'Texto > OpenType > Alternativas de Título',
        placement: 'MenuBar',
        name: 'Alternativas de Título',
    },
    {
        id: 3342,
        label: 'Texto > OpenType > Ornamentos',
        placement: 'MenuBar',
        name: 'Ornamentos',
    },
    {
        id: 3343,
        label: 'Texto > OpenType > Números Ordinais',
        placement: 'MenuBar',
        name: 'Números Ordinais',
    },
    {
        id: 3344,
        label: 'Texto > OpenType > Frações',
        placement: 'MenuBar',
        name: 'Frações',
    },
    {
        id: 3345,
        label: 'Texto > OpenType > Japonês 78',
        placement: 'MenuBar',
        name: 'Japonês 78',
    },
    {
        id: 3346,
        label: 'Texto > OpenType > Japonês Profissional',
        placement: 'MenuBar',
        name: 'Japonês Profissional',
    },
    {
        id: 3347,
        label: 'Texto > OpenType > Japonês Tradicional',
        placement: 'MenuBar',
        name: 'Japonês Tradicional',
    },
    {
        id: 3348,
        label: 'Texto > OpenType > Kana',
        placement: 'MenuBar',
        name: 'Kana',
    },
    {
        id: 3349,
        label: 'Texto > OpenType > Roman Itálico',
        placement: 'MenuBar',
        name: 'Roman Itálico',
    },
    {
        id: 3350,
        label: 'Texto > Painéis > Painel de parágrafos',
        placement: 'MenuBar',
        name: 'Painel de parágrafos',
    },
    {
        id: 3350,
        label: 'Janela > Parágrafo',
        placement: 'MenuBar',
        name: 'Parágrafo',
    },
    {
        id: 3370,
        label: 'Texto > Suavização de serrilhado > Nenhuma',
        placement: 'MenuBar',
        name: 'Nenhuma',
    },
    {
        id: 3371,
        label: 'Texto > Suavização de serrilhado > Bem definida',
        placement: 'MenuBar',
        name: 'Bem definida',
    },
    {
        id: 3372,
        label: 'Texto > Suavização de serrilhado > Sólida',
        placement: 'MenuBar',
        name: 'Sólida',
    },
    {
        id: 3373,
        label: 'Texto > Suavização de serrilhado > Suave',
        placement: 'MenuBar',
        name: 'Suave',
    },
    {
        id: 3374,
        label: 'Texto > Suavização de serrilhado > Nítida',
        placement: 'MenuBar',
        name: 'Nítida',
    },
    {
        id: 3375,
        label: 'Texto > Suavização de serrilhado > LCD Mac',
        placement: 'MenuBar',
        name: 'LCD Mac',
    },
    {
        id: 3376,
        label: 'Texto > Suavização de serrilhado > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: 'Texto > Converter Tipo de Forma de Texto',
        placement: 'MenuBar',
        name: 'Converter Tipo de Forma de Texto',
    },
    {
        id: 3390,
        label: 'Texto > Atualizar todas as camadas de texto',
        placement: 'MenuBar',
        name: 'Atualizar todas as camadas de texto',
    },
    {
        id: 3392,
        label: 'Editar > Verificar ortografia...',
        placement: 'MenuBar',
        name: 'Verificar ortografia...',
    },
    {
        id: 3393,
        label: 'Editar > Localizar e substituir texto...',
        placement: 'MenuBar',
        name: 'Localizar e substituir texto...',
    },
    {
        id: 3409,
        label: 'Camada > Combinar formas > Unir formas',
        placement: 'MenuBar',
        name: 'Unir formas',
    },
    {
        id: 3410,
        label: 'Camada > Combinar formas > Subtrair forma frontal',
        placement: 'MenuBar',
        name: 'Subtrair forma frontal',
    },
    {
        id: 3411,
        label: 'Camada > Combinar formas > Unir formas na sobreposição',
        placement: 'MenuBar',
        name: 'Unir formas na sobreposição',
    },
    {
        id: 3412,
        label: 'Camada > Combinar formas > Subtrair formas na sobreposição',
        placement: 'MenuBar',
        name: 'Subtrair formas na sobreposição',
    },
    {
        id: 3438,
        label: 'Camada > Copiar SVG',
        placement: 'MenuBar',
        name: 'Copiar SVG',
    },
    {
        id: 3439,
        label: 'Camada > Copiar CSS',
        placement: 'MenuBar',
        name: 'Copiar CSS',
    },
    {
        id: 3443,
        label: 'Arquivo > Exportar > Exportar como...',
        placement: 'MenuBar',
        name: 'Exportar como...',
    },
    {
        id: 3444,
        label: 'Arquivo > Exportar > Exportação rápida como PNG',
        placement: 'MenuBar',
        name: 'Exportação rápida como PNG',
    },
    {
        id: 3446,
        label: 'Camada > Exportação rápida como PNG',
        placement: 'MenuBar',
        name: 'Exportação rápida como PNG',
    },
    {
        id: 3447,
        label: 'Camada > Exportar como...',
        placement: 'MenuBar',
        name: 'Exportar como...',
    },
    {
        id: 3451,
        label: 'Texto > Opções de idioma > Algarismos arábicos LTR - 123%',
        placement: 'MenuBar',
        name: 'Algarismos arábicos LTR - 123%',
    },
    {
        id: 3452,
        label: 'Texto > Opções de idioma > Dígitos farsi',
        placement: 'MenuBar',
        name: 'Dígitos farsi',
    },
    {
        id: 3453,
        label: 'Texto > Opções de idioma > Dígitos híndi',
        placement: 'MenuBar',
        name: 'Dígitos híndi',
    },
    {
        id: 3459,
        label: 'Texto > Opções de idioma > Algarismos arábicos RTL - %123',
        placement: 'MenuBar',
        name: 'Algarismos arábicos RTL - %123',
    },
    {
        id: 3500,
        label: 'Visualizar > Extras',
        placement: 'MenuBar',
        name: 'Extras',
    },
    {
        id: 3501,
        label: 'Visualizar > Mostrar > Arestas de seleção',
        placement: 'MenuBar',
        name: 'Arestas de seleção',
    },
    {
        id: 3502,
        label: 'Visualizar > Mostrar > Demarcador de Destino',
        placement: 'MenuBar',
        name: 'Demarcador de Destino',
    },
    {
        id: 3503,
        label: 'Visualizar > Mostrar > Guias',
        placement: 'MenuBar',
        name: 'Guias',
    },
    {
        id: 3504,
        label: 'Visualizar > Mostrar > Grade',
        placement: 'MenuBar',
        name: 'Grade',
    },
    {
        id: 3505,
        label: 'Visualizar > Mostrar > Fatias',
        placement: 'MenuBar',
        name: 'Fatias',
    },
    {
        id: 3506,
        label: 'Visualizar > Mostrar > Notas',
        placement: 'MenuBar',
        name: 'Notas',
    },
    {
        id: 3507,
        label: 'Visualizar > Mostrar > Tudo',
        placement: 'MenuBar',
        name: 'Tudo',
    },
    {
        id: 3508,
        label: 'Visualizar > Mostrar > Nada',
        placement: 'MenuBar',
        name: 'Nada',
    },
    {
        id: 3510,
        label: 'Visualizar > Mostrar > Mostrar Opções de Extras...',
        placement: 'MenuBar',
        name: 'Mostrar Opções de Extras...',
    },
    {
        id: 3511,
        label: 'Visualizar > Mostrar > Guias Inteligentes',
        placement: 'MenuBar',
        name: 'Guias Inteligentes',
    },
    {
        id: 3512,
        label: 'Visualizar > Mostrar > Arestas da Camada',
        placement: 'MenuBar',
        name: 'Arestas da Camada',
    },
    {
        id: 3513,
        label: 'Visualizar > Mostrar > Contagem',
        placement: 'MenuBar',
        name: 'Contagem',
    },
    {
        id: 3514,
        label: 'Visualizar > Mostrar > Grade de Pixel',
        placement: 'MenuBar',
        name: 'Grade de Pixel',
    },
    {
        id: 3517,
        label: 'Visualizar > Mostrar > Malha',
        placement: 'MenuBar',
        name: 'Malha',
    },
    {
        id: 3520,
        label: 'Visualizar > Ajustar',
        placement: 'MenuBar',
        name: 'Ajustar',
    },
    {
        id: 3521,
        label: 'Visualizar > Ajustar a > Guias',
        placement: 'MenuBar',
        name: 'Guias',
    },
    {
        id: 3522,
        label: 'Visualizar > Ajustar a > Grade',
        placement: 'MenuBar',
        name: 'Grade',
    },
    {
        id: 3523,
        label: 'Visualizar > Ajustar a > Fatias',
        placement: 'MenuBar',
        name: 'Fatias',
    },
    {
        id: 3524,
        label: 'Visualizar > Ajustar a > Limites do Documento',
        placement: 'MenuBar',
        name: 'Limites do Documento',
    },
    {
        id: 3527,
        label: 'Visualizar > Ajustar a > Tudo',
        placement: 'MenuBar',
        name: 'Tudo',
    },
    {
        id: 3528,
        label: 'Visualizar > Ajustar a > Nada',
        placement: 'MenuBar',
        name: 'Nada',
    },
    {
        id: 3530,
        label: 'Visualizar > Ajustar a > Camadas',
        placement: 'MenuBar',
        name: 'Camadas',
    },
    {
        id: 3532,
        label: 'Visualizar > Mostrar > Limites do bloco de visualização de padrão',
        placement: 'MenuBar',
        name: 'Limites do bloco de visualização de padrão',
    },
    {
        id: 3533,
        label: 'Visualizar > Mostrar > Guias da prancheta',
        placement: 'MenuBar',
        name: 'Guias da prancheta',
    },
    {
        id: 3535,
        label: 'Visualizar > Mostrar > Nomes de pranchetas',
        placement: 'MenuBar',
        name: 'Nomes de pranchetas',
    },
    {
        id: 3536,
        label: 'Visualizar > Mostrar > Guias de telas',
        placement: 'MenuBar',
        name: 'Guias de telas',
    },
    {
        id: 3541,
        label: 'Camada > Rasterizar > Forma',
        placement: 'MenuBar',
        name: 'Forma',
    },
    {
        id: 3542,
        label: 'Camada > Rasterizar > Texto',
        placement: 'MenuBar',
        name: 'Texto',
    },
    {
        id: 3542,
        label: 'Texto > Rasterizar texto',
        placement: 'MenuBar',
        name: 'Rasterizar texto',
    },
    {
        id: 3544,
        label: 'Camada > Rasterizar > Conteúdo de preenchimento',
        placement: 'MenuBar',
        name: 'Conteúdo de preenchimento',
    },
    {
        id: 3545,
        label: 'Camada > Rasterizar > Todas as camadas',
        placement: 'MenuBar',
        name: 'Todas as camadas',
    },
    {
        id: 3547,
        label: 'Camada > Rasterizar > Camada',
        placement: 'MenuBar',
        name: 'Camada',
    },
    {
        id: 3549,
        label: 'Camada > Objetos inteligentes > Rasterizar',
        placement: 'MenuBar',
        name: 'Rasterizar',
    },
    {
        id: 3549,
        label: 'Camada > Rasterizar > Objeto inteligente',
        placement: 'MenuBar',
        name: 'Objeto inteligente',
    },
    {
        id: 3551,
        label: 'Camada > Rasterizar > Vídeo',
        placement: 'MenuBar',
        name: 'Vídeo',
    },
    {
        id: 3553,
        label: 'Camada > Rasterizar > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: 'Camada > Camadas de vídeo > Rasterizar',
        placement: 'MenuBar',
        name: 'Rasterizar',
    },
    {
        id: 3557,
        label: 'Camada > Rasterizar > Estilo de camada',
        placement: 'MenuBar',
        name: 'Estilo de camada',
    },
    {
        id: 3561,
        label: 'Camada > Rasterizar > Generativo',
        placement: 'MenuBar',
        name: 'Generativo',
    },
    {
        id: 3585,
        label: 'Visualizar > Mostrar > Editar pinos',
        placement: 'MenuBar',
        name: 'Editar pinos',
    },
    {
        id: 3911,
        label: 'Filtro > Filtros de última geração > Blur (Gaussian)',
        placement: 'MenuBar',
        name: 'Blur (Gaussian)',
    },
    {
        id: 4002,
        label: 'Ajuda > Atualizações...',
        placement: 'MenuBar',
        name: 'Atualizações...',
    },
    {
        id: 4210,
        label: 'Janela > Predefinições de Ferramenta',
        placement: 'MenuBar',
        name: 'Predefinições de Ferramenta',
    },
    {
        id: 5059,
        label: 'Camada > Máscara de camada > Excluir',
        placement: 'MenuBar',
        name: 'Excluir',
    },
    {
        id: 5068,
        label: 'Editar > Colar especial > Colar fora',
        placement: 'MenuBar',
        name: 'Colar fora',
    },
    {
        id: 5069,
        label: 'Selecionar > Editar no modo máscara rápida',
        placement: 'MenuBar',
        name: 'Editar no modo máscara rápida',
    },
    {
        id: 5085,
        label: 'Camada > Máscara de camada > Vincular',
        placement: 'MenuBar',
        name: 'Vincular',
    },
    {
        id: 5095,
        label: 'Camada > Máscara de camada > Aplicar',
        placement: 'MenuBar',
        name: 'Aplicar',
    },
    {
        id: 5115,
        label: 'Janela > Área de Trabalho > Nova área de trabalho...',
        placement: 'MenuBar',
        name: 'Nova área de trabalho...',
    },
    {
        id: 5116,
        label: 'Janela > Área de Trabalho > Excluir Área de Trabalho...',
        placement: 'MenuBar',
        name: 'Excluir Área de Trabalho...',
    },
    {
        id: 5117,
        label: 'Janela > Área de Trabalho > Redefinir Essenciais',
        placement: 'MenuBar',
        name: 'Redefinir Essenciais',
    },
    {
        id: 5217,
        label: 'Camada > Nova fatia com base em camadas',
        placement: 'MenuBar',
        name: 'Nova fatia com base em camadas',
    },
    {
        id: 5226,
        label: 'Camada > Filtro inteligente > Excluir Máscara de Filtro',
        placement: 'MenuBar',
        name: 'Excluir Máscara de Filtro',
    },
    {
        id: 5613,
        label: 'Visualizar > Guias > Nova Guia...',
        placement: 'MenuBar',
        name: 'Nova Guia...',
    },
    {
        id: 5614,
        label: 'Visualizar > Guias > Novo Layout de guias…',
        placement: 'MenuBar',
        name: 'Novo Layout de guias…',
    },
    {
        id: 5615,
        label: 'Visualizar > Guias > Novas guias da Forma',
        placement: 'MenuBar',
        name: 'Novas guias da Forma',
    },
    {
        id: 5624,
        label: 'Editar > Definir forma personalizada...',
        placement: 'MenuBar',
        name: 'Definir forma personalizada...',
    },
    {
        id: 5634,
        label: 'Janela > Área de Trabalho > Essenciais (Padrão)',
        placement: 'MenuBar',
        name: 'Essenciais (Padrão)',
    },
    {
        id: 5929,
        label: 'Janela > Organizar > Trazer Tudo para Frente',
        placement: 'MenuBar',
        name: 'Trazer Tudo para Frente',
    },
    {
        id: 5930,
        label: 'Janela > Organizar > Em Cascata',
        placement: 'MenuBar',
        name: 'Em Cascata',
    },
    {
        id: 5931,
        label: 'Janela > Organizar > Lado a lado',
        placement: 'MenuBar',
        name: 'Lado a lado',
    },
    {
        id: 5932,
        label: 'Janela > Organizar > Minimizar',
        placement: 'MenuBar',
        name: 'Minimizar',
    },
    {
        id: 5933,
        label: 'Janela > Organizar > Todos Lado a Lado Verticalmente',
        placement: 'MenuBar',
        name: 'Todos Lado a Lado Verticalmente',
    },
    {
        id: 5934,
        label: 'Janela > Organizar > Todos Lado a Lado Horizontalmente',
        placement: 'MenuBar',
        name: 'Todos Lado a Lado Horizontalmente',
    },
    {
        id: 5935,
        label: 'Janela > Organizar > 2 impressões na horizontal',
        placement: 'MenuBar',
        name: '2 impressões na horizontal',
    },
    {
        id: 5936,
        label: 'Janela > Organizar > 2 impressões na vertical',
        placement: 'MenuBar',
        name: '2 impressões na vertical',
    },
    {
        id: 5937,
        label: 'Janela > Organizar > 3 impressões na horizontal',
        placement: 'MenuBar',
        name: '3 impressões na horizontal',
    },
    {
        id: 5938,
        label: 'Janela > Organizar > 3 impressões na vertical',
        placement: 'MenuBar',
        name: '3 impressões na vertical',
    },
    {
        id: 5939,
        label: 'Janela > Organizar > 3 impressões empilhadas',
        placement: 'MenuBar',
        name: '3 impressões empilhadas',
    },
    {
        id: 5940,
        label: 'Janela > Organizar > 4 impressões',
        placement: 'MenuBar',
        name: '4 impressões',
    },
    {
        id: 5941,
        label: 'Janela > Organizar > 6 impressões',
        placement: 'MenuBar',
        name: '6 impressões',
    },
    {
        id: 5956,
        label: 'Ajuda > Ajuda do Photoshop...',
        placement: 'MenuBar',
        name: 'Ajuda do Photoshop...',
    },
    {
        id: 5957,
        label: 'Editar > Pesquisar',
        placement: 'MenuBar',
        name: 'Pesquisar',
    },
    {
        id: 5960,
        label: 'Janela > Organizar > Corresponder Zoom',
        placement: 'MenuBar',
        name: 'Corresponder Zoom',
    },
    {
        id: 5962,
        label: 'Janela > Organizar > Corresponder Local',
        placement: 'MenuBar',
        name: 'Corresponder Local',
    },
    {
        id: 5963,
        label: 'Janela > Organizar > Corresponder ao Giro',
        placement: 'MenuBar',
        name: 'Corresponder ao Giro',
    },
    {
        id: 5964,
        label: 'Janela > Organizar > Corresponder a Todos',
        placement: 'MenuBar',
        name: 'Corresponder a Todos',
    },
    {
        id: 5966,
        label: 'Arquivo > Compartilhar para revisão',
        placement: 'MenuBar',
        name: 'Compartilhar para revisão',
    },
    {
        id: 5967,
        label: 'Arquivo > Convidar para editar...',
        placement: 'MenuBar',
        name: 'Convidar para editar...',
    },
    {
        id: 5968,
        label: 'Arquivo > Exportar > Enviar para o Quadros do Firefly',
        placement: 'MenuBar',
        name: 'Enviar para o Quadros do Firefly',
    },
    {
        id: 5980,
        label: 'Editar > Atalhos de teclado...',
        placement: 'MenuBar',
        name: 'Atalhos de teclado...',
    },
    {
        id: 5981,
        label: 'Janela > Área de Trabalho > Menus e Atalhos do Teclado...',
        placement: 'MenuBar',
        name: 'Menus e Atalhos do Teclado...',
    },
    {
        id: 5982,
        label: 'Editar > Menus...',
        placement: 'MenuBar',
        name: 'Menus...',
    },
    {
        id: 5983,
        label: 'Editar > Barra de ferramentas...',
        placement: 'MenuBar',
        name: 'Barra de ferramentas...',
    },
    {
        id: 5991,
        label: 'Visualizar > Modo de tela > Modo de Tela Padrão',
        placement: 'MenuBar',
        name: 'Modo de Tela Padrão',
    },
    {
        id: 5992,
        label: 'Visualizar > Modo de tela > Modo de Tela Cheia com Barra de Menus',
        placement: 'MenuBar',
        name: 'Modo de Tela Cheia com Barra de Menus',
    },
    {
        id: 5993,
        label: 'Visualizar > Modo de tela > Modo de Tela Cheia',
        placement: 'MenuBar',
        name: 'Modo de Tela Cheia',
    },
    {
        id: 5996,
        label: 'Janela > Organizar > Sobrepor na janela',
        placement: 'MenuBar',
        name: 'Sobrepor na janela',
    },
    {
        id: 5997,
        label: 'Janela > Organizar > Sobrepor todos em janelas',
        placement: 'MenuBar',
        name: 'Sobrepor todos em janelas',
    },
    {
        id: 5998,
        label: 'Janela > Organizar > Consolidar tudo para guias',
        placement: 'MenuBar',
        name: 'Consolidar tudo para guias',
    },
    {
        id: 6300,
        label: 'Camada > Nova camada de preenchimento > Cor sólida...',
        placement: 'MenuBar',
        name: 'Cor sólida...',
    },
    {
        id: 6301,
        label: 'Camada > Nova camada de preenchimento > Degradê...',
        placement: 'MenuBar',
        name: 'Degradê...',
    },
    {
        id: 6302,
        label: 'Camada > Nova camada de preenchimento > Padrão...',
        placement: 'MenuBar',
        name: 'Padrão...',
    },
    {
        id: 6303,
        label: 'Camada > Nova camada de ajuste > Níveis...',
        placement: 'MenuBar',
        name: 'Níveis...',
    },
    {
        id: 6304,
        label: 'Camada > Nova camada de ajuste > Curvas...',
        placement: 'MenuBar',
        name: 'Curvas...',
    },
    {
        id: 6305,
        label: 'Camada > Nova camada de ajuste > Equilíbrio de cores...',
        placement: 'MenuBar',
        name: 'Equilíbrio de cores...',
    },
    {
        id: 6306,
        label: 'Camada > Nova camada de ajuste > Brilho/Contraste...',
        placement: 'MenuBar',
        name: 'Brilho/Contraste...',
    },
    {
        id: 6308,
        label: 'Camada > Nova camada de ajuste > Matiz/Saturação...',
        placement: 'MenuBar',
        name: 'Matiz/Saturação...',
    },
    {
        id: 6309,
        label: 'Camada > Nova camada de ajuste > Cor seletiva...',
        placement: 'MenuBar',
        name: 'Cor seletiva...',
    },
    {
        id: 6310,
        label: 'Camada > Nova camada de ajuste > Misturador de canais...',
        placement: 'MenuBar',
        name: 'Misturador de canais...',
    },
    {
        id: 6311,
        label: 'Camada > Nova camada de ajuste > Mapa de degradê...',
        placement: 'MenuBar',
        name: 'Mapa de degradê...',
    },
    {
        id: 6312,
        label: 'Camada > Nova camada de ajuste > Filtro de fotos...',
        placement: 'MenuBar',
        name: 'Filtro de fotos...',
    },
    {
        id: 6313,
        label: 'Camada > Nova camada de ajuste > Inverter...',
        placement: 'MenuBar',
        name: 'Inverter...',
    },
    {
        id: 6314,
        label: 'Camada > Nova camada de ajuste > Limiar...',
        placement: 'MenuBar',
        name: 'Limiar...',
    },
    {
        id: 6315,
        label: 'Camada > Nova camada de ajuste > Posterizar...',
        placement: 'MenuBar',
        name: 'Posterizar...',
    },
    {
        id: 6332,
        label: 'Camada > Objetos inteligentes > Editar conteúdo',
        placement: 'MenuBar',
        name: 'Editar conteúdo',
    },
    {
        id: 6333,
        label: 'Camada > Objetos inteligentes > Substituir conteúdo...',
        placement: 'MenuBar',
        name: 'Substituir conteúdo...',
    },
    {
        id: 6334,
        label: 'Camada > Objetos inteligentes > Exportar conteúdo...',
        placement: 'MenuBar',
        name: 'Exportar conteúdo...',
    },
    {
        id: 6337,
        label: 'Camada > Nova camada de ajuste > Pesquisa de cores...',
        placement: 'MenuBar',
        name: 'Pesquisa de cores...',
    },
    {
        id: 6339,
        label: 'Camada > Objetos inteligentes > Converter para vinculado...',
        placement: 'MenuBar',
        name: 'Converter para vinculado...',
    },
    {
        id: 6340,
        label: 'Camada > Objetos inteligentes > Revincular ao arquivo…',
        placement: 'MenuBar',
        name: 'Revincular ao arquivo…',
    },
    {
        id: 6341,
        label: 'Camada > Objetos inteligentes > Revincular ao gráfico da biblioteca…',
        placement: 'MenuBar',
        name: 'Revincular ao gráfico da biblioteca…',
    },
    {
        id: 6342,
        label: 'Camada > Objetos inteligentes > Atualizar conteúdo modificado',
        placement: 'MenuBar',
        name: 'Atualizar conteúdo modificado',
    },
    {
        id: 6343,
        label: 'Camada > Objetos inteligentes > Atualizar todo o conteúdo modificado',
        placement: 'MenuBar',
        name: 'Atualizar todo o conteúdo modificado',
    },
    {
        id: 6345,
        label: 'Camada > Objetos inteligentes > Incorporar vinculados',
        placement: 'MenuBar',
        name: 'Incorporar vinculados',
    },
    {
        id: 6346,
        label: 'Camada > Objetos inteligentes > Incorporar todos os vinculados',
        placement: 'MenuBar',
        name: 'Incorporar todos os vinculados',
    },
    {
        id: 6347,
        label: 'Camada > Objetos inteligentes > Redefinir transformação',
        placement: 'MenuBar',
        name: 'Redefinir transformação',
    },
    {
        id: 6348,
        label: 'Camada > Nova camada de ajuste > Preto-e-Branco...',
        placement: 'MenuBar',
        name: 'Preto-e-Branco...',
    },
    {
        id: 6351,
        label: 'Camada > Camadas de vídeo > Nova camada de vídeo a partir do arquivo...',
        placement: 'MenuBar',
        name: 'Nova camada de vídeo a partir do arquivo...',
    },
    {
        id: 6352,
        label: 'Camada > Camadas de vídeo > Nova camada de vídeo em branco',
        placement: 'MenuBar',
        name: 'Nova camada de vídeo em branco',
    },
    {
        id: 6353,
        label: 'Camada > Camadas de vídeo > Inserir quadro em branco',
        placement: 'MenuBar',
        name: 'Inserir quadro em branco',
    },
    {
        id: 6354,
        label: 'Camada > Camadas de vídeo > Duplicar quadro',
        placement: 'MenuBar',
        name: 'Duplicar quadro',
    },
    {
        id: 6355,
        label: 'Camada > Camadas de vídeo > Excluir quadro',
        placement: 'MenuBar',
        name: 'Excluir quadro',
    },
    {
        id: 6356,
        label: 'Camada > Camadas de vídeo > Interpretar sequência de imagens...',
        placement: 'MenuBar',
        name: 'Interpretar sequência de imagens...',
    },
    {
        id: 6357,
        label: 'Camada > Camadas de vídeo > Substituir sequência de imagens...',
        placement: 'MenuBar',
        name: 'Substituir sequência de imagens...',
    },
    {
        id: 6358,
        label: 'Camada > Camadas de vídeo > Mostrar vídeo alterado',
        placement: 'MenuBar',
        name: 'Mostrar vídeo alterado',
    },
    {
        id: 6360,
        label: 'Camada > Camadas de vídeo > Restaurar quadro',
        placement: 'MenuBar',
        name: 'Restaurar quadro',
    },
    {
        id: 6361,
        label: 'Camada > Camadas de vídeo > Restaurar todos os quadros',
        placement: 'MenuBar',
        name: 'Restaurar todos os quadros',
    },
    {
        id: 6362,
        label: 'Arquivo > Importar > Quadros de vídeo para camadas...',
        placement: 'MenuBar',
        name: 'Quadros de vídeo para camadas...',
    },
    {
        id: 6363,
        label: 'Camada > Camadas de vídeo > Recarregar quadro',
        placement: 'MenuBar',
        name: 'Recarregar quadro',
    },
    {
        id: 6400,
        label: 'Visualizar > Opções de visualização em 32 Bits...',
        placement: 'MenuBar',
        name: 'Opções de visualização em 32 Bits...',
    },
    {
        id: 6432,
        label: 'Camada > Objetos inteligentes > Modo de pilha > Nenhum',
        placement: 'MenuBar',
        name: 'Nenhum',
    },
    {
        id: 6440,
        label: 'Filtro > Converter para Filtros inteligentes',
        placement: 'MenuBar',
        name: 'Converter para Filtros inteligentes',
    },
    {
        id: 6478,
        label: 'Janela > Propriedades',
        placement: 'MenuBar',
        name: 'Propriedades',
    },
    {
        id: 6479,
        label: 'Janela > Ajustes',
        placement: 'MenuBar',
        name: 'Ajustes',
    },
    {
        id: 6651,
        label: 'Camada > Nova camada de ajuste > Claridade e desembaçamento…',
        placement: 'MenuBar',
        name: 'Claridade e desembaçamento…',
    },
    {
        id: 6652,
        label: 'Camada > Nova camada de ajuste > Granulação',
        placement: 'MenuBar',
        name: 'Granulação',
    },
    {
        id: 7763,
        label: 'Janela > Degradês',
        placement: 'MenuBar',
        name: 'Degradês',
    },
    {
        id: 7767,
        label: 'Janela > Padrões',
        placement: 'MenuBar',
        name: 'Padrões',
    },
    {
        id: 7772,
        label: 'Janela > Formas',
        placement: 'MenuBar',
        name: 'Formas',
    },
    {
        id: 7785,
        label: 'Janela > Content Credentials (Beta)',
        placement: 'MenuBar',
        name: 'Content Credentials (Beta)',
    },
    {
        id: 7788,
        label: 'Janela > Materiais',
        placement: 'MenuBar',
        name: 'Materiais',
    },
    {
        id: 7789,
        label: 'Filtro > Filtros paramétricos...',
        placement: 'MenuBar',
        name: 'Filtros paramétricos...',
    },
    {
        id: 7800,
        label: 'Imagem > Aplicar conjunto de dados...',
        placement: 'MenuBar',
        name: 'Aplicar conjunto de dados...',
    },
    {
        id: 7802,
        label: 'Imagem > Variáveis > Definir...',
        placement: 'MenuBar',
        name: 'Definir...',
    },
    {
        id: 7803,
        label: 'Imagem > Variáveis > Conjuntos de dados...',
        placement: 'MenuBar',
        name: 'Conjuntos de dados...',
    },
    {
        id: 7805,
        label: 'Arquivo > Importar > Conjunto de dados variáveis...',
        placement: 'MenuBar',
        name: 'Conjunto de dados variáveis...',
    },
    {
        id: 7806,
        label: 'Arquivo > Exportar > Conjuntos de dados como arquivos...',
        placement: 'MenuBar',
        name: 'Conjuntos de dados como arquivos...',
    },
    {
        id: 7900,
        label: 'Imagem > Análise > Ferramenta contagem',
        placement: 'MenuBar',
        name: 'Ferramenta contagem',
    },
    {
        id: 7930,
        label: 'Janela > Quadro do aplicativo',
        placement: 'MenuBar',
        name: 'Quadro do aplicativo',
    },
    {
        id: 8820,
        label: 'Filtro > Neural Filters...',
        placement: 'MenuBar',
        name: 'Neural Filters...',
    },
    {
        id: 9066,
        label: 'Texto > Painéis > Painel de estilos de caractere',
        placement: 'MenuBar',
        name: 'Painel de estilos de caractere',
    },
    {
        id: 9066,
        label: 'Janela > Estilos de caractere',
        placement: 'MenuBar',
        name: 'Estilos de caractere',
    },
    {
        id: 9067,
        label: 'Texto > Painéis > Painel de estilos de parágrafo',
        placement: 'MenuBar',
        name: 'Painel de estilos de parágrafo',
    },
    {
        id: 9067,
        label: 'Janela > Estilos de parágrafo',
        placement: 'MenuBar',
        name: 'Estilos de parágrafo',
    },
    {
        id: 9068,
        label: 'Texto > Painéis > Painel Glifos',
        placement: 'MenuBar',
        name: 'Painel Glifos',
    },
    {
        id: 9068,
        label: 'Janela > Glifos',
        placement: 'MenuBar',
        name: 'Glifos',
    },
    {
        id: 9086,
        label: 'Texto > OpenType > Justification Alternates',
        placement: 'MenuBar',
        name: 'Justification Alternates',
    },
    {
        id: 9087,
        label: 'Texto > Gerenciar fontes ausentes',
        placement: 'MenuBar',
        name: 'Gerenciar fontes ausentes',
    },
    {
        id: 9100,
        label: 'Texto > Opções de idioma > Recursos padrão',
        placement: 'MenuBar',
        name: 'Recursos padrão',
    },
    {
        id: 9101,
        label: 'Texto > Opções de idioma > Recursos do leste asiático',
        placement: 'MenuBar',
        name: 'Recursos do leste asiático',
    },
    {
        id: 9102,
        label: 'Texto > Opções de idioma > Recursos do Oriente Médio',
        placement: 'MenuBar',
        name: 'Recursos do Oriente Médio',
    },
    {
        id: 9109,
        label: 'Texto > Tamanho de visualização da fonte > Nenhuma',
        placement: 'MenuBar',
        name: 'Nenhuma',
    },
    {
        id: 9110,
        label: 'Texto > Tamanho de visualização da fonte > Pequena',
        placement: 'MenuBar',
        name: 'Pequena',
    },
    {
        id: 9111,
        label: 'Texto > Tamanho de visualização da fonte > Média',
        placement: 'MenuBar',
        name: 'Média',
    },
    {
        id: 9112,
        label: 'Texto > Tamanho de visualização da fonte > Grande',
        placement: 'MenuBar',
        name: 'Grande',
    },
    {
        id: 9113,
        label: 'Texto > Tamanho de visualização da fonte > Extragrande',
        placement: 'MenuBar',
        name: 'Extragrande',
    },
    {
        id: 9114,
        label: 'Texto > Tamanho de visualização da fonte > Enorme',
        placement: 'MenuBar',
        name: 'Enorme',
    },
    {
        id: 9119,
        label: 'Texto > Colar Lorem Ipsum',
        placement: 'MenuBar',
        name: 'Colar Lorem Ipsum',
    },
    {
        id: 9121,
        label: 'Texto > Carregar estilos de padrão',
        placement: 'MenuBar',
        name: 'Carregar estilos de padrão',
    },
    {
        id: 9122,
        label: 'Texto > Salvar estilos de padrão',
        placement: 'MenuBar',
        name: 'Salvar estilos de padrão',
    },
    {
        id: 9123,
        label: 'Texto > Localizar fonte semelhante...',
        placement: 'MenuBar',
        name: 'Localizar fonte semelhante...',
    },
    {
        id: 9130,
        label: 'Texto > Opções de idioma > Alinhamento de Roman Vertical Padrão',
        placement: 'MenuBar',
        name: 'Alinhamento de Roman Vertical Padrão',
    },
    {
        id: 9131,
        label: 'Texto > Opções de idioma > Tate-chu-yoko',
        placement: 'MenuBar',
        name: 'Tate-chu-yoko',
    },
    {
        id: 9132,
        label: 'Texto > Opções de idioma > Entrelinha a partir do topo das Linhas',
        placement: 'MenuBar',
        name: 'Entrelinha a partir do topo das Linhas',
    },
    {
        id: 9133,
        label: 'Texto > Opções de idioma > Entrelinha a partir da Base das Linhas',
        placement: 'MenuBar',
        name: 'Entrelinha a partir da Base das Linhas',
    },
    {
        id: 9137,
        label: 'Texto > Opções de idioma > Kashidas',
        placement: 'MenuBar',
        name: 'Kashidas',
    },
    {
        id: 9138,
        label: 'Texto > Opções de idioma > Direção padrão',
        placement: 'MenuBar',
        name: 'Direção padrão',
    },
    {
        id: 9139,
        label: 'Texto > Opções de idioma > Direção de caractere da esquerda para direita',
        placement: 'MenuBar',
        name: 'Direção de caractere da esquerda para direita',
    },
    {
        id: 9140,
        label: 'Texto > Opções de idioma > Direção do Caractere da Direita para Esquerda',
        placement: 'MenuBar',
        name: 'Direção do Caractere da Direita para Esquerda',
    },
    {
        id: 9143,
        label: 'Editar > Colar especial > Colar sem formatar',
        placement: 'MenuBar',
        name: 'Colar sem formatar',
    },
    {
        id: 9220,
        label: 'Camada > Nova > Prancheta...',
        placement: 'MenuBar',
        name: 'Prancheta...',
    },
    {
        id: 9221,
        label: 'Camada > Nova > Prancheta a partir do grupo',
        placement: 'MenuBar',
        name: 'Prancheta a partir do grupo',
    },
    {
        id: 9222,
        label: 'Camada > Nova > Prancheta a partir de camadas...',
        placement: 'MenuBar',
        name: 'Prancheta a partir de camadas...',
    },
    {
        id: 9252,
        label: 'Camada > Nova > Quadro a partir de camadas...',
        placement: 'MenuBar',
        name: 'Quadro a partir de camadas...',
    },
    {
        id: 9255,
        label: 'Camada > Nova > Converter para quadro',
        placement: 'MenuBar',
        name: 'Converter para quadro',
    },
    {
        id: 9600,
        label: 'Janela > Barra de tarefas contextual',
        placement: 'MenuBar',
        name: 'Barra de tarefas contextual',
    },
    {
        id: 11600,
        label: 'Camada > Harmonizar',
        placement: 'MenuBar',
        name: 'Harmonizar',
    },
    {
        id: 15004,
        label: 'Ajuda > Informações do Sistema...',
        placement: 'MenuBar',
        name: 'Informações do Sistema...',
    },
    {
        id: 15009,
        label: 'Ajuda > Compatibilidade com GPU...',
        placement: 'MenuBar',
        name: 'Compatibilidade com GPU...',
    },
    {
        id: 15019,
        label: 'Ajuda > Saiba mais sobre créditos generativos',
        placement: 'MenuBar',
        name: 'Saiba mais sobre créditos generativos',
    },
    {
        id: 15020,
        label: 'Ajuda > Diretrizes do usuário da IA generativa da Adobe',
        placement: 'MenuBar',
        name: 'Diretrizes do usuário da IA generativa da Adobe',
    },
    {
        id: 15201,
        label: 'Arquivo > Pesquisar Adobe Stock…',
        placement: 'MenuBar',
        name: 'Pesquisar Adobe Stock…',
    },
    {
        id: 15202,
        label: 'Arquivo > Pesquisar modelos do Adobe Express...',
        placement: 'MenuBar',
        name: 'Pesquisar modelos do Adobe Express...',
    },
    {
        id: 15203,
        label: 'Ajuda > Tutoriais práticos...',
        placement: 'MenuBar',
        name: 'Tutoriais práticos...',
    },
    {
        id: 15204,
        label: 'Ajuda > Novidades...',
        placement: 'MenuBar',
        name: 'Novidades...',
    },
    {
        id: 17001,
        label: 'Editar > Distorção de perspectiva',
        placement: 'MenuBar',
        name: 'Distorção de perspectiva',
    },
    {
        id: 20006,
        label: 'Arquivo > Histórico da versão',
        placement: 'MenuBar',
        name: 'Histórico da versão',
    },
    {
        id: 20007,
        label: 'Janela > Histórico da versão',
        placement: 'MenuBar',
        name: 'Histórico da versão',
    },
    {
        id: 20008,
        label: 'Janela > Comentários',
        placement: 'MenuBar',
        name: 'Comentários',
    },
    {
        id: 21000,
        label: 'Camada > Objetos inteligentes > Converter em camadas',
        placement: 'MenuBar',
        name: 'Converter em camadas',
    },
    {
        id: 21001,
        label: 'Visualizar > Ajustar camada(s) na tela',
        placement: 'MenuBar',
        name: 'Ajustar camada(s) na tela',
    },
    {
        id: 22003,
        label: 'Visualizar > Guias > Editar guias selecionadas',
        placement: 'MenuBar',
        name: 'Editar guias selecionadas',
    },
    {
        id: 22004,
        label: 'Visualizar > Guias > Apagar guias selecionadas',
        placement: 'MenuBar',
        name: 'Apagar guias selecionadas',
    },
    {
        id: 22100,
        label: 'Camada > Mascarar todos os objetos',
        placement: 'MenuBar',
        name: 'Mascarar todos os objetos',
    },
    {
        id: 23150,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 23151,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 23152,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 23153,
        label: 'Filtro > Último filtro',
        placement: 'MenuBar',
        name: 'Último filtro',
    },
    {
        id: 25070,
        label: 'Editar > Girar objeto',
        placement: 'MenuBar',
        name: 'Girar objeto',
    },
    {
        id: 26010,
        label: 'Editar > Remoção de reflexos…',
        placement: 'MenuBar',
        name: 'Remoção de reflexos…',
    },
    {
        id: 30900,
        label: 'Arquivo > Coloque imagens gratuitas do Adobe Stock…',
        placement: 'MenuBar',
        name: 'Coloque imagens gratuitas do Adobe Stock…',
    },
    {
        id: 'paintbrushTool',
        label: 'Ferramenta Pincel',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: 'Ferramenta Pincel de ajuste',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: 'Ferramenta Lápis',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: 'Ferramenta Substituição de cor',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: 'Ferramenta Pincel de mistura',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: 'Ferramenta Borracha',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: 'Ferramenta Borracha de Plano de Fundo',
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: 'Ferramenta Carimbo',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: 'Ferramenta Carimbo de padronagem',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: 'Ferramenta Pincel de recuperação',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: 'Ferramenta Pincel do Histórico',
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: 'Ferramenta Pincel História da Arte',
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: 'Ferramenta Borrar',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: 'Ferramenta Desfoque',
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: 'Ferramenta Nitidez',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: 'Ferramenta Subexposição',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: 'Ferramenta Superexposição',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: 'Ferramenta Esponja',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: 'Ferramenta Olhos vermelhos',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: 'Ferramenta Letreiro retangular',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: 'Ferramenta Letreiro Elíptico',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: 'Ferramenta Letreiro de Linha Única',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: 'Ferramenta Letreiro de Coluna Única',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: 'Ferramenta Mover',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: 'Ferramenta Prancheta',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: 'Ferramenta Laço',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: 'Ferramenta Pincel de seleção',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: 'Ferramenta Seleção de objeto',
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: 'Ferramenta Laço Poligonal',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: 'Ferramenta Laço Magnético',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: 'Ferramenta Varinha Mágica',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: 'Ferramenta de Seleção rápida',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: 'Ferramenta Corte',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: 'Ferramenta Corte da perspectiva',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: 'Ferramenta Fatia',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: 'Ferramenta Seleção de Fatia',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: 'Ferramenta Borracha Mágica',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: 'Ferramenta Degradê',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: 'Ferramenta Lata de tinta',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: 'Ferramenta Seleção de demarcador',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: 'Ferramenta Seleção Direta',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: 'Ferramenta Caneta',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: 'Ferramenta Caneta de forma livre',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: 'Ferramenta Caneta de curvatura',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: 'Ferramenta Adicionar ponto de ancoragem',
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: 'Ferramenta Excluir Ponto de Ancoragem',
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: 'Ferramenta Converter pontos',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: 'Ferramenta Texto horizontal',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: 'Ferramenta Texto vertical',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: 'Ferramenta Máscara de texto horizontal',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: 'Ferramenta Máscara de texto vertical',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: 'Ferramenta Retângulo',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: 'Ferramenta Elipse',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: 'Ferramenta Triângulo',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: 'Ferramenta Polígono',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: 'Ferramenta Linha',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: 'Ferramenta Forma personalizada',
        placement: 'Tool',
    },
    {
        id: 'StarTool',
        label: 'Ferramenta Estrela',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: 'Ferramenta Quadro',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: 'Ferramenta Conta-gotas',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: 'Ferramenta Classificador de Cores',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: 'Ferramenta Régua',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: 'Ferramenta Notas',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: 'Ferramenta Mão',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: 'Ferramenta Girar visualização',
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: 'Ferramenta Zoom',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: 'Ferramenta Correção',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: 'Ferramenta Mover sensível ao conteúdo',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: 'Ferramenta Pincel de recuperação para manchas',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: 'Ferramenta Remover',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: 'Editar barra de ferramentas…',
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: 'Ferramenta Contagem',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: 'Ações',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: 'Degradês',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: 'Estilos',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: 'Amostras',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: 'Padrões',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: 'Histograma',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: 'Informações',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: 'Demarcadores',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: 'Formas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: 'Predefinições de Ferramenta',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: 'Cor',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: 'Canais',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: 'Camadas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: 'Composições de Camadas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: 'Linha do Tempo',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: 'Origem do clone',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: 'Registro de medidas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.hdrpreview',
        label: 'Visualização de HDR',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: 'Histórico',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: 'Navegador',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: 'Caractere',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: 'Parágrafo',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: 'Estilos de caractere',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: 'Estilos de parágrafo',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: 'Glifos',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: 'Notas',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: 'Propriedades',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cai.uxp/panel',
        label: 'Content Credentials (Beta)',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cclibrariespanel/ccLibrariesPanel',
        label: 'Bibliotecas',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.ccx.comments-webview/ccx-comments-uxp-webview',
        label: 'Comentários',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: 'Barra de contexto : Texto dinâmico',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: 'Painel : Texto dinâmico',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: 'Ferramenta : Texto dinâmico',
        placement: 'Option',
    },
];
